"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module ae-api
 * @description This module provides the api to thehub-Services for the Web Portal.
 * The module exports 'api' which in turn passes on
 * all the functions from the modules that comprise the 'ae-api'.
 */
var qs = require("qs");
var Fetch = require("fetch-ponyfill")({
	Promise: require("promise")
});

var fetch = Fetch.fetch;
var FormData = require("form-data");
var querystring = require("query-string");
var global = require("global");
var mime = require("mime-types");


module.exports = api;

/**
 * This function is a factory pattern for producing instances of the ae-api.  It
 * takes 'config' which should contain a token and a host.
 * @param  {object} config Contains two properties: token, host
 * @return {Object}        'api' is a factory pattern
 */
function api(config) {
	var host = config.host;
	var token = config.token;

	return {
		admin: require("./admin.js")(config, get, post, upload),
		atouchaway: require("./atouchaway.js")(config, get, post, upload),
		auth: require("./auth.js")(config, get, post, upload),
		banner: require("./banner.js")(config, get, post, upload),
		calls: require("./calls.js")(config, get, post, upload),
		careplan: require("./careplan.js")(config, get, post, upload),
		contacts: require("./contacts.js")(config, get, post, upload),
		device: require("./device.js")(config, get, post, upload),
		forms: require("./forms.js")(config, get, post, upload),
		machine: require("./machine.js")(config, get, post, upload),
		manage: require("./manage.js")(config, get, post, upload),
		messages: require("./messages.js")(config, get, post, upload),
		groupchat: require("./groupchat.js")(config, get, post, upload),
		nologin: require("./nologin.js")(config, get, post, upload),
		notifications: require("./notifications.js")(config, get, post, upload),
		oauth: require("./oauth.js")(config, get, post, upload),
		org: require("./org/index.js")(config, { get, newGet }, post, upload),
		people: require("./people.js")(config, get, post, upload),
		push: require("./push.js")(config, get, post, upload),
		reminders: require("./reminders.js")(config, get, post, upload),
		schedule: require("./schedule.js")(config, get, post, upload),
		timeline: require("./timeline.js")(config, get, post, upload),
		trial: require("./trial.js")(config, get, post, upload),
		urgency: require("./urgency.js")(config, get, post, upload),
		version: require("./version.js")(config, get, post, upload),
		survey: require("./survey.js")(config, get, post, upload),
		workflow: require("./workflow.js")(config, get, post, upload),
		status: require("./status.js")(config, get, post, upload),
		callgroups: require("./callgroups.js")(config, get, post, upload),
		resources: require("./resources")(config, get, post, upload),
		weather: require("./weather")(config, get, post, upload),
		devices: require("./devices")(config, get, post, upload),
		livechat: require("./livechat")(config, get, post, upload),
		managegroup: require("./managegroup")(config, get, post, upload),
		exportpresets: require("./exportpresets")(config, get, post, upload),
		options: require("./options")(config, get, post, upload),
		indicators: require("./customindicators")(config, get, post),
		persiststorage: require("./persiststorage")(config, get, post),
		meeting: require("./meeting")(config, get, post),
		item: require("./item")(config, newGet, post, upload),
		kit: require("./kit")(config, newGet, post, upload)
	};

	function get(path, data) {
		data = data || {};
		if (!data.token) data.token = token;
		var query = querystring.stringify(data);
		return fetch(host + path + "?" + query).then(handle_response);
	}

	function newGet(path, data) {
		data = data || {};
		if (!data.token) data.token = token;
		var query = qs.stringify(data);
		return fetch(host + path + "?" + query).then(handle_response);
	}

	function post(path, data) {
		data = data || {};
		if (!data.token) data.token = token;
		return fetch(host + path, {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify(data)
		}).then(handle_response);
	}

	function upload(path, data, fileField, file) {
		data = data || {};
		if (!data.token) data.token = token;
		var query = querystring.stringify(data);
		if (file.isCordova) {
			return uploadCordovaFile(file, fileField, path, data, host, form, query);
		}
		var form = new FormData();
		form.append(fileField, file);
		return fetch(host + path + "?" + query, {
			method: "POST",
			body: form
		}).then(handle_response);
	}
}


function uploadCordovaFile(file, fileField, path, data, host, form, query) {
	return new Promise(function (resolve, reject) {
		var fileURL = file.url;

		function success (r) {
			resolve(JSON.parse(r.response));
		}

		function fail (error) {
			reject(error);
			console.log("An error has occurred: Code = " + error.code);
		}
		var options = new global.FileUploadOptions();
		options.fileKey = fileField;
		options.fileName = fileURL.substr(fileURL.lastIndexOf("/") + 1);
		options.httpMethod = "POST";
		options.mimeType = mime.lookup(fileURL);
		var params = {};
		params.form = form;
		options.params = params;
		options.chunkedMode = false;
		var ft = new global.FileTransfer();
		ft.upload(fileURL, encodeURI(host + path + "?" + query), success, fail, options);
	}).then(function(response) {
		if (file.isVideo) {
			removeFileFromLibrary(file.url);
		}
		else {
			global.navigator.camera.cleanup();
		}

		return response;
	});
}

function removeFileFromLibrary(path) {
	return new Promise(function (resolve, reject) {
		var tempPath = path.split("/");
		var relativeFilePath = tempPath.slice(0, 6).join("/");
		var file = tempPath.slice(6).join("/");
		function success () {
			console.log("File removed!");
		}

		function fail (error) {
			reject(error);
			console.log("error deleting the file " + error.code);
		}

		window.resolveLocalFileSystemURL(relativeFilePath, function(fileSystem){
			fileSystem.getFile(file, {
				create: false
			},
			function(fileEntry){
				fileEntry.remove(success, fail);
			}, function(error){
				reject(error);
				console.log("file does not exist");
			});
		}, fail);
	});
}


function handle_response(response) {
	var status = response.status;
	return response.json().then(function (result) {
		if (status >= 400) {
			var error = new Error("Server responded with status of " + status);
			error.status = status;
			error.response = result;
			throw error;
		}
		return result;
	});
}
